/* eslint-disable @upgrade/require-palette-colors */

import styled from 'styled-components';
import { Button, FormField } from '@upgrade/react-components';
import { Hero as CommonHero } from '../common/styles';

/**
 * These experimental styled components are part of an Optimizely Experiment.
 *
 * The colors being used here are not currently available in our Theme/Palette, so they are
 * fixed here for now.
 *
 * Once we get a proper Dark Theme, we can get rid of it.
 */
export const CTAButtonExperiment = styled(Button)`
  background-color: #158715;
  border: #158715;

  @media (hover: hover) {
    &:hover {
      background-color: #0e680e;
      border-color: #0e680e;
    }
  }
`;

export const HeroExperiment = styled(CommonHero)`
  background-color: #102c3d;
`;

export const FormFieldExperiment = styled(FormField)`
  [data-error='true'] {
    color: #fa5f50;
  }
`;
